export default __webpack_public_path__ + "static/media/ai_2.948fc655.svg";